"use strict";function clearWebStoreCache$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.clearWebStoreCache$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.clearWebStoreCache";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.pc]={vs:"6.0.22"},_a)),exports.clearWebStoreCache$=clearWebStoreCache$,exports.default=clearWebStoreCache$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/clearWebStoreCache.js
// module id = 1002
// module chunks = 106